<template>
    <div v-if="model">
        <div @click="gotoDetail(model)" class="ebook-card">
            <div class="ebook-card-top">
                <div class="ebook-image-container">
                    <img :src="model.CourseImage" :alt="model.DisplayName" width="288" height="376"
                        class="ebook-cover-image" />

                    <!-- <div class="kips-logo-overlay">
                    <img src="/assets/images/banner/kips-logo.svg" alt="KIPS Publications" class="kips-logo" />
                </div> -->
                    <!-- <div class="ebook-badge-overlay">
                    <span class="ebook-badge">eBook</span>
                </div> -->
                    <div class="additional-badges"
                        v-if="model.EnableTrial || model.IsFree || (model.PaymentPlans.length === 0 && !model.IsFree && !model.IsSpecialActivity)">
                        <span v-show="model.EnableTrial" class="badge trial-badge">Free Trial</span>
                        <span v-show="model.IsFree" class="badge free-badge">Free</span>
                        <!-- <span v-if="model.PaymentPlans.length === 0 && !model.IsFree && !model.IsSpecialActivity"
                            class="badge coming-soon-badge">Coming Soon</span> -->
                    </div>
                </div>

                <div class="ebook-content">
                    <h4 class="ebook-title" :title="model.DisplayName">
                        {{ model.DisplayName }}
                    </h4>
                    <div class="ebook-pricing" v-if="model.PaymentPlans.length">
                        <span class="current-price">Rs. {{ getMinValue.PriceDisplay.slice(3, -3) }}</span>
                        <span v-if="getMinValue.PriceStrikethrough" class="original-price">Rs. {{
                            getMinValue.PriceStrikethroughDisplay.slice(3, -3) }}</span>
                    </div>
                    <div v-else-if="!model.IsSpecialActivity && !model.IsFree" class="ebook-pricing">
                        <span class="coming-soon-text-ebook">Coming Soon</span>
                    </div>

                </div>
            </div>
            <button class="ebook-details-btn">
                eBook Details
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CartModel } from "../models/app/cartModel";
import { appConstants } from "../common/constants";
import { courseDetail as courseDetailStoreKeys, course as courseStoreKeys, classCourses as classCoursesStoreKeys, checkout as checkoutStoreKeys, cart as cartStoreKeys } from "../store/keys";
import cryptojs from "../plugins/crypto";
import { common } from "../mixins/common";

export default {
    name: 'EbooksCard',
    mixins: [common],
    props: {
        model: null,
        programCategoryId: null,
    },
    data() {
        return {
            isTrial: false,
            selectedPaymentOption: appConstants.enums.PaymentOption.PaymentPlan,
        };
    },
    computed: {
        ...mapGetters(courseDetailStoreKeys.namespace, courseDetailStoreKeys.getters),
        ...mapGetters(courseStoreKeys.namespace, courseStoreKeys.getters),
        ...mapGetters(cartStoreKeys.namespace, cartStoreKeys.getters),
        ...mapGetters(classCoursesStoreKeys.namespace, classCoursesStoreKeys.getters),
        getMinValue() {
            if (this.model && this.model.PaymentPlans.length) {
                return this.model.PaymentPlans.reduce((previous, current) => {
                    return current.Price < previous.Price ? current : previous;
                });
            }
        },
    },
    methods: {
        ...mapActions(courseDetailStoreKeys.namespace, courseDetailStoreKeys.actions),
        ...mapActions(courseStoreKeys.namespace, courseStoreKeys.actions),
        ...mapActions(cartStoreKeys.namespace, cartStoreKeys.actions),
        ...mapActions(checkoutStoreKeys.namespace, checkoutStoreKeys.actions),
        ...mapActions(classCoursesStoreKeys.namespace, classCoursesStoreKeys.actions),

        gotoDetail(model) {
            this.$router
                .push({
                    name: "classebookDetail",
                    params: {
                        course: this.RemoveSpecialChars(model.SOSName),
                        sosId: cryptojs.UTF.encrypt(model.SOSId),
                        courseGroupId: cryptojs.UTF.encrypt(model.CourseGroupId),
                    },
                })
                .catch(() => { });
        },
    },
};
</script>

<style scoped>
.coming-soon-text-ebook {
    color: #000000;
    font-weight: 400;
    font-size: 16px;
}

.ebook-card-top {
    /* padding: 20px 20px 0 20px; */
    padding: 30px 30px 0 30px;
}

.ebook-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 348px;
    margin-inline: auto;
    overflow: visible;
}

.ebook-card:hover {
    /* transform: translateY(-2px); */
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Image Container - Specific height like the design */
.ebook-image-container {
    position: relative;
    max-width: 100%;
    width: 100%;
    height: auto;
    margin-bottom: 12px;
    background-color: #EEEFF7;
    border-radius: 4px;
}

.ebook-image-container img {
    max-width: 288px;
    border-radius: 4px;
    width: 100%;
    margin-inline: auto;
    display: block;
}


/* KIPS Logo Overlay (Top Left) */
.kips-logo-overlay {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 2;
}

.kips-logo {
    height: 30px;
    width: auto;
}

/* eBook Badge (Top Right) */
.ebook-badge-overlay {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 2;
}

.ebook-badge {
    background: #28a745;
    color: white;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Additional Badges */
.additional-badges {
    position: absolute;
    top: 60px;
    right: 15px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    z-index: 2;
}

.badge {
    padding: 4px 8px;
    border-radius: 15px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.trial-badge {
    background: #17a2b8;
    color: white;
}

.free-badge {
    background: #ffc107;
    color: #212529;
}

.coming-soon-badge {
    background: #6c757d;
    color: white;
}

/* Content Below Image */
.ebook-content {
    /* padding: 16px 20px 20px 20px; */
    background: #fff;
    display: flex;
    flex-direction: column;
}

.ebook-title {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
    margin: 0;
    line-height: 1.4;
    text-align: left;
    margin-bottom: 8px;
}

/* Pricing */
.ebook-pricing {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 8px;
}

.current-price {
    font-size: 16px;
    font-weight: 600;
    color: #000;
}

.original-price {
    font-size: 14px;
    color: #999;
    text-decoration: line-through;
}

.coming-soon-text {
    color: #ffc107;
    font-weight: 600;
    font-size: 16px;
}

/* Action Button */
.ebook-details-btn {
    width: 100%;
    padding: 15px 0;
    background: #ffffff;
    border: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    color: #000000;
    font-weight: 600;
    font-size: 14px;
    /* transition: all 0.3s ease; */
    cursor: pointer;
    border-top: 1px solid #f1f2f8;
}


.ebook-card:hover .ebook-details-btn {
    background: #6163B0;
    color: #ffffff;
}

/* Responsive Design */
@media (max-width: 768px) {

    .ebook-title {
        font-size: 15px;
        margin-bottom: 6px;
    }

    .current-price {
        font-size: 15px;
    }

    .ebook-pricing {
        margin-bottom: 14px;
    }

    .kips-logo {
        height: 25px;
    }

    .ebook-badge {
        font-size: 11px;
        padding: 5px 10px;
    }
}

@media (max-width: 576px) {
    .ebook-title {
        font-size: 14px;
        margin-bottom: 5px;
    }

    .current-price {
        font-size: 14px;
    }

    .ebook-pricing {
        margin-bottom: 12px;
    }
}

@media (min-width:768px) {
    .ebook-card-top {
        padding: 40px 40px 0 40px;
    }
}

@media (min-width:1400px) {
    .ebook-card {
        max-width: 400px;
    }

    .ebook-image-container img {
        max-width: 242px;
    }
}
</style>